/**
 * @description 回答Controller
 * @date 2019-03-29
 * @author jywang
 */
import React, { PureComponent } from 'react';
import { toJS } from 'mobx';
import { inject } from 'mobx-react';
import toast from '@util/toast';
import tool from '@util/tool';

const WithPublicQuestionController = (ComponentCon) => {
    @inject('store')
    class PublicQuesitonController extends PureComponent<any, any> {
        constructor(props) {
            super(props);
            this.state = {
                hasClickSubmit: false,
            };
        }
        public componentWillMount() {
            this.props.store.hasLoginManage();
            const id = this.props.match.params.id;
            this.getDetail(id);
        }
        public render() {
            const newProps = {
                submitBtn: this.submitBtn,
                ...this.state,
            };
            return (
                <ComponentCon {...newProps} />
            );
        }
        public submitBtn = () => {
            this.setState({
                hasClickSubmit: true,
            });
            const { store } = this.props;
            console.log(store.addQuestion);
            if (!store.addQuestion.content) {
                toast.error('请输入回答描述');
                this.setState({
                    hasClickSubmit: false,
                });
                return;
            }
            if (store.addQuestion.content && store.addQuestion.content.length > 10000) {
                toast.error('回答描述不可超过10000个字符');
                this.setState({
                    hasClickSubmit: false,
                });
                return;
            }
            const param_box: any = {};
            const param: any = {};
            const bridge: any = {};
            param.name = tool.trimStr(store.addQuestion.name);
            param.content = tool.trimStr(store.addQuestion.content);
            param.questionProductId = this.props.match.params.id;
            if (store.addQuestion.type === 0) {
                param.images = toJS(store.addQuestion.images);
                bridge.pic = param;
            } else if (store.addQuestion.type === 1) {
                const video = toJS(store.addQuestion.video);
                bridge.video = { ...param, ...video };
            }
            console.log(bridge);
            param_box.answer = bridge;
            store.publicQuestion.set_v2(param_box).then((res) => {
                console.log('发布成功====>', res);
                window.location.href = '/question';
            }).catch((err) => {
                toast.error(err.msg);
                this.setState({
                    hasClickSubmit: false,
                });
            });
        }
        public getDetail = (id) => {
            this.props.store.getDetail.get(id);
        }
    }
    return PublicQuesitonController;
};

export default WithPublicQuestionController;
